export const selectedSeriesId = ({ selectedSeriesId }) => selectedSeriesId;

export const pipelineDataByBodyStyleId = ({ seriesPipeline }, { seriesId }) => {
  if (seriesPipeline.byId && seriesPipeline.byId[seriesId]) {
    const { pipelineByBodyStyleId } = seriesPipeline.byId[seriesId];
    return pipelineByBodyStyleId;
  }
  return {};
};

export const bodyStyleIds = ({ seriesPipeline }, { seriesId }) =>
  seriesPipeline.byId[seriesId]
    ? Object.keys(seriesPipeline.byId[seriesId].pipelineByBodyStyleId)
    : [];

export const seriesBodyStylePipeline = (
  { seriesPipeline },
  { seriesId, bodyStyleId },
) => {
  if (seriesPipeline.byId[seriesId]) {
    return seriesPipeline.byId[seriesId].pipelineByBodyStyleId[bodyStyleId];
  }
  return {};
};

export const seriesBodyStyleDescription = (
  { seriesPipeline },
  { seriesId, bodyStyleId },
) => {
  if (seriesPipeline.byId[seriesId]) {
    let brandBodyStyles =
      seriesPipeline.byId[seriesId].bodyStyles.length > 0
        ? seriesPipeline.byId[seriesId].bodyStyles
        : seriesPipeline.byId[seriesId].vgModels;
    let result = brandBodyStyles.filter(bodyStyle => {
      return bodyStyleId === bodyStyle.id;
    });
    return result[0].description;
  }
  return '';
};
